import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const soundImporterSelectors = importerSelectors(
  'sound.importer',
);

export default soundImporterSelectors;
